<template>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalLivraisonAddCommande'"
        ref="modalLivraisonAddCommandeRef" :dialogClass="'modal-dialog modal-lg'" @save="saveCommandeToLivraison">

        <label for="livraison_libelle">Date de livraison {{ livraison.dateLivraison }}</label>



        <table>
            <thead>
                <tr>
                    <th></th>
                    <th>Nom</th>
                    <th>Prenom</th>
                    <th>Localité</th>
                    <th>Quantité</th>
                    <th>Notes</th>
                </tr>

            </thead>
            <tbody v-if="commandes && commandes.length">
                <tr v-for="(commande, index) in paginatedItems" :key="commande.id">
                    <td>
                        <input type="checkbox" :value="commande.id" v-model="selectedCommandes" />
                    </td>
                    <td>{{ commande.identite.nom }}</td>
                    <td>{{ commande.identite.prenom }}</td>
                    <td>{{ commande.identite.adresse.localite }}</td>
                    <td>{{ commande.quantiteBois }}</td>
                    <td>{{ commande.notes }}</td>
                </tr>
            </tbody>
            <tfoot v-else>
                <tr>
                    <td colspan="7" class="emptyTableMessage">Aucune Commande trouvé</td>
                </tr>
            </tfoot>
        </table>
        <div class="pagination">

            <a v-on:click="previousPage()" :disabled="currentPage === 1">
                <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_left</i>
            </a>
            <span>Page {{ currentPage }} sur {{ totalPages }}</span>
            <a v-on:click="nextPage()" :disabled="currentPage === totalPages">
                <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_right</i>
            </a>
        </div>
    </ModalEdition>
</template>

<script>
import Axios from '@/services/axios.service';
import PaginationService from '@/services/pagination.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
    name: 'livraisonAddCommande',
    mixins: [PaginationService],
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            livraison: {},
            commandes: {},
            errors: [],
            selectedCommandes: [],
        }
    },
    methods: {
        getLivraisonAndStock(id) {
            Axios.get('/livraison/' + id).then(res => {
                this.livraison = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement de la livraison :', err);
            });

            Axios.get('/commande/nonLivre').then(res => {
                this.commandes = res.data;
                this.items = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des fraisLivraison :', err);
            });
        },
        async saveCommandeToLivraison() {
            this.errors = []

            if (!this.selectedCommandes.length) {
                this.errors.push("Aucune commande sélectionnée.");
                return;
            }

            const promises = this.selectedCommandes.map(async (id) => {
                const commande = this.commandes.find(c => c.id === id);

                if (!commande) return;
                commande.livraison = this.livraison;
                return Axios.post('/commande', commande);
            });

            try {
                await Promise.all(promises);
                this.$refs.modalLivraisonAddCommandeRef.closeModal();
                this.$emit('saved');
            } catch (error) {
                console.error("Erreur lors de la sauvegarde des commandes sélectionnées :", error);
                this.errors.push("Erreur lors de la sauvegarde.");
            }
        }
    },
    watch: {
        params: {
            handler(params) {
                if (params.id != null) {
                    this.getLivraisonAndStock(params.id);
                }
            }
        },
    },
}
</script>

<style></style>